<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Attività Team di {{ nome_capobarca }}</v-toolbar-title
      >

      <v-spacer></v-spacer>

      <span class="mr-3" style="font-size: 16px; color: white">Data:</span>
      <v-menu
        v-model="calendario_data"
        :close-on-content-click="false"
        :nudge-right="40"
        min-width="289"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            background-color="#ffffff"
            class="mr-5"
            solo
            dense
            hide-details
            label="Data Selezionata"
            v-model="data_formattata"
            readonly
            v-on="on"
            style="max-width: 200px"
          >
          </v-text-field>
        </template>
        <v-date-picker
          v-model="data_sel"
          @input="
            calendario_data = false;
            getTeam();
          "
        ></v-date-picker>
      </v-menu>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaModifiche" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text class="mt-5">
      <v-data-table
        :headers="headers_team"
        :items="items_team"
        :height="'50vh'"
        fixed-header
      >
        <template v-slot:item="{ item }">
          <tr>
            <td style="text-align: left">
              {{ item.nominativo }}
            </td>
            <td
              style="text-align: left"
              v-for="elem in items_colonne"
              :key="elem.value"
            >
              <v-text-field
                class="input-class centered-input"
                type="number"
                v-model.number="item[elem.cod]"
                style="max-width: 75px"
              ></v-text-field>
            </td>
          </tr>
        </template>
        <!--
        <template v-slot:[`item.rif_prem`]="{ item }">
          <v-text-field
            class="input-class centered-input"
            type="number"
            v-model.number="item.rif_prem"
            style="max-width: 75px"
          ></v-text-field>
        </template>
        <template v-slot:[`item.guscio`]="{ item }">
          <v-text-field
            class="input-class centered-input"
            type="number"
            v-model.number="item.guscio"
            style="max-width: 75px"
          ></v-text-field>
        </template>
        <template v-slot:[`item.coperta`]="{ item }">
          <v-text-field
            class="input-class centered-input"
            type="number"
            v-model.number="item.coperta"
            style="max-width: 75px"
          ></v-text-field>
        </template>
        <template v-slot:[`item.vassoio`]="{ item }">
          <v-text-field
            class="input-class centered-input"
            type="number"
            v-model.number="item.vassoio"
            style="max-width: 75px"
          ></v-text-field>
        </template>
        <template v-slot:[`item.calzata`]="{ item }">
          <v-text-field
            class="input-class centered-input"
            type="number"
            v-model.number="item.calzata"
            style="max-width: 75px"
          ></v-text-field>
        </template>
        <template v-slot:[`item.magazzino`]="{ item }">
          <v-text-field
            class="input-class centered-input"
            type="number"
            v-model.number="item.magazzino"
            style="max-width: 75px"
          ></v-text-field>
        </template>-->
      </v-data-table>
    </v-card-text>

    <!-- Overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: { SnackbarQV },
  props: {
    id_capobarca: {
      type: Number,
      default: null,
    },
    items_colonne: {
      type: Array,
      default: () => [],
    },
    riga_sel: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      data_sel: null,
      nome_capobarca: null,

      // Modal
      calendario_data: false,
      overlay: false,

      // Array
      headers_stabili: [
        {
          text: "Nominativo",
          value: "nominativo",
          sortable: false,
          align: "left",
        },
      ],
      headers_team: [
        {
          text: "Nominativo",
          value: "nominativo",
          sortable: false,
          align: "left",
        },
        {
          text: "Rif. Prem",
          value: "rif_prem",
          sortable: false,
        },
        {
          text: "Guscio",
          value: "guscio",
          sortable: false,
        },
        {
          text: "Coperta",
          value: "coperta",
          sortable: false,
        },
        {
          text: "Vassoio",
          value: "vassoio",
          sortable: false,
        },
        {
          text: "Calzata",
          value: "calzata",
          sortable: false,
        },
        {
          text: "Magazzino",
          value: "magazzino",
          sortable: false,
        },
      ],
      items_team: new Array(),
    };
  },
  computed: {
    data_formattata() {
      return this.data_sel != ""
        ? moment(this.data_sel).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    items_colonne: {
      immediate: true,
      handler() {
        this.headers_team = new Array();
        this.headers_stabili.forEach((h) => this.headers_team.push(h));
        this.items_colonne.forEach((c) =>
          this.headers_team.push({
            text: c.des,
            value: c.cod,
            sortable: false,
            whdth: "75px",
          })
        );
      },
    },
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.data_sel = moment().format("YYYY-MM-DD");
          this.getTeam();
        }
      },
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("chiudi_modifica_ore");
    },
    getOre(arg_str, arg_data, arg_id_commessa_dettaglio) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getore",
          token: localStorage.user_token,
          id_personale: arg_str,
          data: arg_data,
          id_commessa_dettaglio: arg_id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Il BE mi restituisce solo le righe degli
             * operatori che hanno qualche ora lavorata.
             * Se un operatore non ha ore registrate per
             * quel giorno, non lo vedo in questa chiamata.
             * Precedentemente mi sono messo da parte tutti
             * i membri della squadra, senza ore. Quelli che ora
             * mi vengono restituiti dal BE, li aggiorno.
             * Quelli che il BE non mi restituisce rimangono
             * com'erano, ma almeno ci sono e posso inputargli
             * delle ore di lavoro. */
            res.data.result.forEach((e) => {
              for (let i = 0; i < this.items_team.length; i++) {
                if (this.items_team[i].id_personale == e.id_personale) {
                  for (let field in this.items_team[i]) {
                    if (
                      field != "id_personale" &&
                      field != "data" &&
                      field != "nominativo" &&
                      e[field] != null
                    )
                      this.$set(this.items_team[i], field, e[field]);
                  }
                }
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    getTeam() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getteam",
          token: localStorage.user_token,
          id_capobarca: this.riga_sel.id_responsabile,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Resetto l'array del team.
            this.items_team = new Array();

            if (res.data.Responsabili.length > 0) {
              this.nome_capobarca = res.data.Responsabili[0].nominativo;
              if (res.data.Dipendenti.length > 0) {
                let str_tmp = ``;
                res.data.Dipendenti.forEach((d) => {
                  str_tmp += "" + d.id_personale + ",";

                  const personale_tmp = {
                    id_personale: d.id_personale,
                    nominativo: d.nominativo,
                  };

                  /* Inserisco nell'oggetto tutte le fasi dinamiche definite dall'utente con una
                   * chiave che serve per preparare un'eventale chiamata di set con cui scrivere su
                   * commessa_movimenti. Questa chiave sarà modificata dalla getOre se ci sono dati. */
                  this.items_colonne.forEach((c) => {
                    personale_tmp[c.cod] = 0;
                    personale_tmp["id_" + c.cod] = -1;
                  });

                  this.items_team.push(personale_tmp);
                });

                str_tmp = str_tmp.substring(0, str_tmp.length - 1);
                this.getOre(
                  str_tmp,
                  this.data_sel,
                  this.riga_sel.id_commessa_dettaglio
                );
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Non sono stati trovati membri per il team di questo capobarca."
                );
              }
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono stati trovati membri per il team di questo capobarca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    salvaModifiche() {
      const arr_tmp = Array.from(this.items_team);

      // Controllo che non siano state dichiarate ore negative
      let chk_ore_negative = true;
      arr_tmp.forEach((e) => {
        if (
          e.guscio < 0 ||
          e.coperta < 0 ||
          e.vassoio < 0 ||
          e.calzata < 0 ||
          e.magazzino < 0 ||
          e.rif_prem < 0
        ) {
          chk_ore_negative = false;
        }
      });

      if (chk_ore_negative === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non può essere dichiarata una quantità di ore negative su un'attività di lavoro."
        );
        return;
      }

      // Controllo che nessuno abbia lavorato più di 24 ore.
      let chk_ore_eccessive = true;

      arr_tmp.forEach((e) => {
        if (
          e.guscio +
            e.coperta +
            e.vassoio +
            e.calzata +
            e.magazzino +
            e.rif_prem >
          24
        ) {
          chk_ore_eccessive = false;
        }
      });

      if (chk_ore_eccessive === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non possono esserci membri del team che risultano aver lavorato più di 24 ore."
        );
        return;
      }

      arr_tmp.forEach((e) => {
        e.id_commessa = this.riga_sel.id_commessa;
        e.id_commessa_dettaglio = this.riga_sel.id_commessa_dettaglio;
        e.data = this.data_sel;
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setdiarioore",
          token: localStorage.user_token,
          items: arr_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;
            this.$emit("salvate_modifiche");
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>